import { FileLabelResponseDto } from '../../file-labels/dto/file-label.response.dto';

// List of file types application works with
export enum FileType {
  IMAGE = 'image',
  PRESENTATION = 'presentation',
  DOC = 'document',
  PDF = 'pdf',
  HTML = 'html',
}

export enum FileSource {
  LOCAL = 'local',
  GOOGLE_DRIVE = 'google_drive',
  CONFLUENCE = 'confluence',
  EXTRACTION = 'EXTRACTION',
  LEGACY_MEDIA = 'legacy_media',
}

export enum FileStatusType {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
  READY = 'READY',
  SKIPPED = 'skipped',
}

export interface FileProcessingStatus {
  status: FileStatusType;
  error?: string;
  completedAt?: string;
}

export interface FileStatus {
  upload: FileProcessingStatus;
  vectorization: FileProcessingStatus;
  extraction: FileProcessingStatus;
}

export interface ExtractedMedia {
  s3FileKey: string;
  originalName: string;
  mimeType: string;
  extractedAt: string;
}

export enum AiProvider {
  OPENAI = 'OPENAI',
}

export interface VectorFileInfo {
  fileId: string;
  provider: AiProvider;
}

export interface OrganizationFileResponse {
  id: string;
  fileName: string;
  status: {
    upload: {
      status: FileStatusType;
      completedAt?: string;
    };
    vectorization: {
      status: FileStatusType;
      completedAt?: string;
    };
    extraction: {
      status: FileStatusType;
      completedAt?: string;
    };
  };
  organizationId: string;
  uploadedAt: string;
  mimeType: string;
  vectorFileId?: string;
  s3FileKey?: string;
  source?: FileSource;
  labels?: FileLabelResponseDto[];
}

export interface UploadFileParams {
  file: Express.Multer.File;
  organizationId: string;
  source?: FileSource;
  userId?: string;
}
